import { render, staticRenderFns } from "./brokerLink.vue?vue&type=template&id=bc0cdd66"
import script from "./brokerLink.vue?vue&type=script&lang=js"
export * from "./brokerLink.vue?vue&type=script&lang=js"
import style0 from "./brokerLink.vue?vue&type=style&index=0&id=bc0cdd66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports